import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const BettingOpportunityWidgetAsyncComponent = AsyncComponent(async () => import('./betting-opportunity-widget' /* webpackChunkName: "betting-opportunity-widget" */ ));

export const BettingOpportunityWidgetAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <BettingOpportunityWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
